export const reportTypesOptions = (permissionsReport = {}, getAll = false) => {
  const reports = [
    {
      text: 'All Reports',
      value: 'all',
      list: ['correlation', 'earnings_preview', 'industry_report', 'ipo_insight'],
      id: 'all',
      color: '#3B4355',
    },
    {
      text: 'Most Downloaded',
      value: 'most_downloaded',
      list: ['correlation', 'earnings_preview', 'industry_report', 'ipo_insight'],
      id: 'most_downloaded',
      order: 'most_downloaded',
      color: '#1FCC67',
    },
    {
      text: 'Correlation',
      value: 'correlation',
      list: ['correlation'],
      id: 'correlation',
      color: '#228BF4',
    },
    {
      text: 'Earnings Preview',
      value: 'earnings_preview',
      list: ['earnings_preview'],
      id: 'earnings_preview',
      color: '#F24979',
    },
    {
      text: 'Industry Report',
      value: 'industry_report',
      list: ['industry_report'],
      id: 'industry_report',
      color: '#9B57F2',
    },
    {
      text: 'Mobile Monthly',
      value: 'mobile_monthly',
      list: ['mobile_monthly'],
      id: 'mobile_monthly',
      color: '#FAAE2A',
    },
    {
      text: 'Best Ideas',
      value: 'best_ideas',
      list: ['best_ideas'],
      id: 'best_ideas',
      color: '#1FCC67',
    },
    {
      text: 'Apptopia Signal',
      value: 'apptopia_signal',
      list: ['apptopia_signal'],
      id: 'apptopia_signal',
      color: '#3B4355',
    },
    {
      text: 'Custom Report',
      value: 'custom_report',
      list: ['custom_report'],
      id: 'custom_report',
      color: '#3B4355',
    },
  ];
  if (getAll || permissionsReport.allowAdvancedDatasets === 'true') {
    reports.push({
      text: 'Apptopia Advanced',
      value: 'apptopia_advanced',
      list: ['apptopia_advanced'],
      id: 'apptopia_advanced',
      color: '#3B4355',
    });
  }
  return reports;
};
